import { render } from "preact";

import { App } from "./App.js";
import "./global.css";

const root = document.getElementById("app");

if (root === null) {
  throw new Error("Missing #app root element");
}

render(<App />, root);
